var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":"","opacity":"0.8","value":!_vm.onLine,"z-index":"0"}},[_c('RotatingLogo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }